// extracted by mini-css-extract-plugin
export default {"wrapper":"GB-z","button":"HB-z","alternate":"IB-z","disabled":"JB-z","paymentWarning":"KB-z","fadeIn":"LB-z"};